'use es6';

import { fromJS, List } from 'immutable';
import { getPropertyFormatter } from '../../../formatters/propertyFormatter';
const getBubbleLegendRanges = layers => {
  const primaryLayer = layers.first();
  const sizingField = primaryLayer.getIn(['sizing', 'field']);
  const sizingProperty = primaryLayer.getIn(['dataset', 'properties', sizingField]);
  const dataValues = layers.reduce((accValues, layer) => {
    return /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */(
      accValues.concat(layer.getIn(['dataset', 'data']).map(row => {
        return row.get(sizingField);
      }))
    );
  }, List([])).filter(val => val);
  const bubMin = dataValues.min();
  const bubMax = dataValues.max();
  const bubMid = (bubMin + bubMax) / 2;
  return List([bubMin, bubMax, bubMid]).toSet().toList().map(value => fromJS({
    value,
    metaData: {
      property: sizingProperty
    }
  }));
};
export const getBubbleLegendOptions = ({
  chart,
  layers
}) => {
  const bubbleLegendRanges = chart.getIn(['options', 'showBubbleLegend']) ? getBubbleLegendRanges(layers) : undefined;
  return fromJS({
    enabled: chart.getIn(['options', 'showBubbleLegend']),
    ranges: bubbleLegendRanges,
    connectorDistance: 40,
    labels: {
      formatter() {
        const formatNumber = getPropertyFormatter(fromJS(this.metaData.property));
        return formatNumber(this.value);
      }
    }
  });
};